import React from 'react';
import { UiTextProps, UiText } from '@open-stack/ui';

export function XTextTitle({ ...rest }: UiTextProps) {
    rest.fontSize = 1;
    rest.weight = 3;

    return <UiText {...rest} />;
}
